import { InjectionToken } from '@angular/core';
import { LANG_HR_NAME, LANG_HR_TRANS } from "./lang-hr";
import { LANG_BS_NAME, LANG_BS_TRANS } from "./lang-bs";
import { LANG_SR_CYR_NAME, LANG_SR_CYR_TRANS } from "./lang-sr-cyr";

export const TRANSLATIONS = new InjectionToken('translations');

// all translations
export const dictionary = {
    [LANG_BS_NAME]: LANG_BS_TRANS,
    [LANG_HR_NAME]: LANG_HR_TRANS,
    [LANG_SR_CYR_NAME]: LANG_SR_CYR_TRANS
}

// providers
export const TRANSLATION_PROVIDERS  = [
    { provide: TRANSLATIONS, useValue: dictionary }
]